import { render } from "./AuthInput.vue?vue&type=template&id=1fbae4c1&scoped=true"
import script from "./AuthInput.vue?vue&type=script&lang=js"
export * from "./AuthInput.vue?vue&type=script&lang=js"

import "./AuthInput.vue?vue&type=style&index=0&id=1fbae4c1&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbae4c1"]])

export default __exports__